import {ERequestType} from 'shared/types/requests';
import {performRequest} from 'shared/utils';

export interface IFetchProjectInvestmentInfoItemArgs {
    id: string | number;
}

export const fetchProjectInvestmentInfoItem = async ({id}: IFetchProjectInvestmentInfoItemArgs) => (
    performRequest({
        url: `ais3/investment.project/${id}`,
        method: ERequestType.GET,
    })
);

